<div class="overlay-spinner">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
